module.exports = __webpack_public_path__ + "img/互动贴纸--大图--挑眉gif.1983fde9.gif";